import _ from 'lodash'
import oldTraffickingScreeningApi from '@/api/oldTraffickingScreening'
import { mergeUserContext } from '@/store/helpers'

const state = {
    oldTraffickingScreeningFile: null,
    oldTraffickingScreenings: [],
    createOldTraffickingScreeningError: false,
    createOldTraffickingScreeningSuccess: false,
    updateOldTraffickingScreeningError: false,
    updateOldTraffickingScreeningSuccess: false,
    downloadOldTraffickingScreeningError: false
}

const getters = {
    getOldTraffickingScreeningFile: state => state.oldTraffickingScreeningFile,
    getOldTraffickingScreenings: state => state.oldTraffickingScreenings,
    getCreateOldTraffickingScreeningError: state => state.createOldTraffickingScreeningError,
    getCreateOldTraffickingScreeningSuccess: state => state.createOldTraffickingScreeningSuccess,
    getUpdateOldTraffickingScreeningError: state => state.updateOldTraffickingScreeningError,
    getUpdateOldTraffickingScreeningSuccess: state => state.updateOldTraffickingScreeningSuccess,
    getDownloadOldTraffickingScreeningError: state => state.downloadOldTraffickingScreeningError
}

const actions = {
    addOldTraffickingScreeningInList ({ commit, state }, payload) {
        const newList = [payload, ...state.oldTraffickingScreenings]
        commit('SET_OLD_TRAFFICKING_SCREENINGS', newList)
    },

    updateOldTraffickingScreeningInList ({ commit, state }, payload) {
        const index = state.oldTraffickingScreenings.findIndex((screening) => screening._id === payload._id)
        if (index <= -1) {
            return
        }

        const newList = [...state.oldTraffickingScreenings]
        newList[index] = payload
        commit('SET_OLD_TRAFFICKING_SCREENINGS', newList)
    },

    async getOldTraffickingScreenings ({ commit, rootState }, payload) {
        payload = mergeUserContext(payload, rootState) || {}

        const response = await oldTraffickingScreeningApi.getOldTraffickingScreenings(payload)
        const screenings = response.body
        screenings.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))

        if (screenings) {
            commit('SET_OLD_TRAFFICKING_SCREENINGS', screenings)
        }
    },

    async downloadOldTraffickingScreening ({ rootState, commit }, payload) {
        payload = mergeUserContext(payload, rootState) || {}
        const response = await oldTraffickingScreeningApi.downloadOldTraffickingScreening(payload)

        if (!response.ok) {
            commit('SET_DOWNLOAD_OLD_TRAFFICKING_SCREENING_ERROR', true)
            return
        }

        commit('SET_DOWNLOAD_OLD_TRAFFICKING_SCREENING_ERROR', false)
        commit('SET_OLD_TRAFFICKING_SCREENING_FILE', response.body)
    },

    async createOldTraffickingScreening ({ commit, dispatch, rootState }, payload) {
        payload = mergeUserContext(payload, rootState)

        const formData = new FormData()
        Object.keys(payload).forEach((key) => {
            if (key === 'fileData') {
                return
            }

            formData.append(key, payload[key])
        })

        if (payload.fileData) {
            formData.append('hasFileData', true)

            // the order matters because skipper seems to only read text parameters
            // until it finds the first file in the stream
            // https://github.com/balderdashy/sails/issues/4897#issuecomment-217556631
            formData.append('fileData', payload.fileData)
        }

        const response = await oldTraffickingScreeningApi.createOldTraffickingScreening(formData)

        if (!response.ok) {
            commit('SET_CREATE_OLD_TRAFFICKING_SCREENING_ERROR', true)
            commit('SET_CREATE_OLD_TRAFFICKING_SCREENING_SUCCESS', false)
        } else {
            commit('SET_CREATE_OLD_TRAFFICKING_SCREENING_ERROR', false)
            commit('SET_CREATE_OLD_TRAFFICKING_SCREENING_SUCCESS', true)
            dispatch('addOldTraffickingScreeningInList', response.body)
        }
    },

    async updateOldTraffickingScreening ({ commit, dispatch, rootState }, payload) {
        payload = mergeUserContext(payload, rootState)

        const screeningId = payload._id
        const toOmit = [
            'id',
            '_id',
            'traffickingType',
            'conclusion',
            'createdAt',
            'createdBy',
            'updatedAt',
            'updatedBy',
            'organizationOwner',
            'organizationCreator'
        ]

        payload = _.omit(payload, toOmit)
        const formData = new FormData()
        Object.keys(payload).forEach((key) => {
            if (key === 'fileData') {
                return
            }

            formData.append(key, payload[key])
        })

        if (payload.fileData) {
            formData.append('hasFileData', true)

            // the order matters because skipper seems to only read text parameters
            // until it finds the first file in the stream
            // https://github.com/balderdashy/sails/issues/4897#issuecomment-217556631
            formData.append('fileData', payload.fileData)
        }

        const response = await oldTraffickingScreeningApi.updateOldTraffickingScreening(formData, screeningId)

        if (!response.ok) {
            commit('SET_UPDATE_OLD_TRAFFICKING_SCREENING_ERROR', true)
            commit('SET_UPDATE_OLD_TRAFFICKING_SCREENING_SUCCESS', false)
        } else {
            commit('SET_UPDATE_OLD_TRAFFICKING_SCREENING_ERROR', false)
            commit('SET_UPDATE_OLD_TRAFFICKING_SCREENING_SUCCESS', true)
            dispatch('updateOldTraffickingScreeningInList', response.body)
        }
    },

    initOldTraffickingScreening ({ commit }) {
        commit('SET_CREATE_OLD_TRAFFICKING_SCREENING_ERROR', false)
        commit('SET_UPDATE_OLD_TRAFFICKING_SCREENING_ERROR', false)
        commit('SET_CREATE_OLD_TRAFFICKING_SCREENING_SUCCESS', false)
        commit('SET_UPDATE_OLD_TRAFFICKING_SCREENING_SUCCESS', false)
        commit('SET_DOWNLOAD_OLD_TRAFFICKING_SCREENING_ERROR', false)
    }
}

const mutations = {
    SET_OLD_TRAFFICKING_SCREENINGS (state, payload) {
        state.oldTraffickingScreenings = payload
    },

    SET_CREATE_OLD_TRAFFICKING_SCREENING_SUCCESS (state, payload) {
        state.createOldTraffickingScreeningSuccess = payload
    },

    SET_CREATE_OLD_TRAFFICKING_SCREENING_ERROR (state, payload) {
        state.createOldTraffickingScreeningError = payload
    },

    SET_UPDATE_OLD_TRAFFICKING_SCREENING_SUCCESS (state, payload) {
        state.updateOldTraffickingScreeningSuccess = payload
    },

    SET_UPDATE_OLD_TRAFFICKING_SCREENING_ERROR (state, payload) {
        state.updateOldTraffickingScreeningError = payload
    },

    SET_OLD_TRAFFICKING_SCREENING_FILE (state, payload) {
        state.oldTraffickingScreeningFile = payload
    },

    SET_DOWNLOAD_OLD_TRAFFICKING_SCREENING_ERROR (state, payload) {
        state.downloadOldTraffickingScreeningError = payload
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/oldTraffickingScreening.js